export default "<p>attachment2 works!</p>\n"